import {customElement, property, query} from 'lit/decorators.js';
import {FlywheelComponent} from '@gl/lit/lib/component.js';
import {ImmutableComponent} from '@gl/lit/components/mixins/immutable_component/index.js';
import type {Constructor} from '@gl/lit/types/classes.js';
import type {Model, Msg} from './architecture.js';
import {main} from './architecture.js';
import styles from './style.scss';
import '@gl/lit/components/base/button/index.js';
import type {AudienceExport} from '@gl/lit/types/audience_exports.js';
import type FlySelect from '../../base/select/index.js';
import type FlyFormInputField from '@gl/lit/components/base/form_input_field/index.js';

export const AUDIENCE_EXPORT_EDIT_ELEMENT_TAG = 'audience-export-edit';

/**
 * Description here; Audience Edit Export modal
 */
@customElement(AUDIENCE_EXPORT_EDIT_ELEMENT_TAG)
export default class AudienceExportEdit extends ImmutableComponent<
  Constructor<FlywheelComponent>,
  Model,
  Msg
>({component: FlywheelComponent, main}) {
  @property({attribute: 'audience-export', type: Object})
  audienceExport?: AudienceExport;

  @property({attribute: 'destination-name', type: String})
  destinationName?: string;

  @property({attribute: 'destination-icon', type: String})
  destinationIcon?: string;

  @property({type: Object})
  frequencies: Record<string, string> = {};

  @property({type: String})
  label = 'Manage';

  @property({type: Boolean})
  isExpired = false;

  @query('fly-select#sync-frequency-select') $syncFrequencySelect?: FlySelect;
  @query('fly-select#end-date-select') $endDateSelect?: FlySelect;
  @query('fly-form-input-field#end-date') $endDate?: FlyFormInputField;

  static get styles() {
    return [styles];
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [AUDIENCE_EXPORT_EDIT_ELEMENT_TAG]: AudienceExportEdit;
  }
}
